import { STORAGE_KEY_URL_QUERIES } from 'constants/StorageKeys'
import { ReactNode, useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import UrlParamsContext, { getSessionStorageValue } from './UrlParamsContextDef'

interface UrlParamsProviderProps {
  children: ReactNode
}

export const UrlParamsProvider = ({ children }: UrlParamsProviderProps) => {
  const navigate = useNavigate()
  const [urlQueries, setValue] = useState<Record<string, string>>(() =>
    getSessionStorageValue(STORAGE_KEY_URL_QUERIES)
  )

  const setUrlQueries = useCallback(
    (value: Record<string, string>, remember = true) => {
      if (remember) {
        sessionStorage.setItem(STORAGE_KEY_URL_QUERIES, JSON.stringify(value))
      }
      setValue(value)
    },
    []
  )

  useEffect(() => {
    // Only restore remembered query params when the URL has none of its own.
    // Explicit params already in the URL (e.g. ?memberId=X from "View profile")
    // must win, otherwise a provider remount mid-navigation would clobber them.
    if (!window.location.search && window.location.pathname in urlQueries) {
      navigate(
        `${window.location.pathname}?${urlQueries[window.location.pathname]}`,
        { replace: true }
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <UrlParamsContext.Provider
      value={{
        urlQueries,
        setUrlQueries
      }}
    >
      {children}
    </UrlParamsContext.Provider>
  )
}
